import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';
import { DeviceInformation } from '../shared/models/device-information';
import { IDeviceItemGrouping, IDeviceNode } from '../shared/models/device';

@Component({
    selector: 'dl-input-section',
    styles: [`
        :host mat-card {
            padding-bottom: 0;
        }

        :host::ng-deep .mat-card-content {
            margin-bottom: 0;
        }
    `],
    templateUrl: './input-section.component.html'
})
export class InputSectionComponent implements OnInit {
    public static $name: string = 'inputSection';

    @Input() public deviceInfo: IDeviceNode;
    @Input('input') public groupSections: IDeviceItemGrouping[];
    @Input() public displayCount: number;
    @Input() public deviceInputForm: FormGroup;
    @Input() public setDeviceInfo: (deviceInfo: DeviceInformation) => void;

    public accentText: string;

    constructor(
        private themeService: ThemeService
    ) {
    }

    public ngOnInit() {
        this.accentText = this.themeService.getTextAccentClass();
    }

    public orderInputs(inputs: Array<{ order: number }>) {
        return inputs.sort((a, b) => a.order - b.order);
    }

    getFilteredGroupSections(): IDeviceItemGrouping[] {
        let filteredGroupSections: IDeviceItemGrouping[] = [];
        // tslint:disable-next-line: prefer-conditional-expression
        if (this.groupSections && this.groupSections.length) {
            filteredGroupSections = this.groupSections.filter((section, index) => section.isVisible && index < this.displayCount);
        }

        return filteredGroupSections;
    }
}
